import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import HomePage from './HomePage';
import WineSelection from './WineSelection';
import Presentation from './pages/Presentation';
import Chateaux from './pages/Chateaux';
import Degustation from './pages/Degustation';
import Credits from './pages/Credits';
import LanguageContext from './LanguageContext';
import './styles.css';

const AppRoutes = () => {
  const [language, setLanguage] = useState('fr');
  const [wineColor, setWineColor] = useState('rouge');
  const navigate = useNavigate();

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      <Routes>
        <Route path="/" element={<HomePage navigate={navigate} />} />
        <Route path="/wine" element={<WineSelection wineColor={wineColor} setWineColor={setWineColor} />} />
        <Route path="/presentation" element={<Presentation />} />
        <Route path="/chateaux" element={<Chateaux />} />
        <Route path="/degustation" element={<Degustation />} />
        <Route path="/credits" element={<Credits />} />
      </Routes>
    </LanguageContext.Provider>
  );
};

const App = () => (
  <Router>
    <AppRoutes />
  </Router>
);

export default App;
